"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/ordermade/v1/ems_service.proto (package spwn.ordermade.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMSOrdermadeFactoryBaseItemRatioRectBorderSpec = exports.EMSOrdermadeFactoryBaseItemRatioRect = exports.EMSOrdermadeFactoryBaseItemSizeOptionValue = exports.EMSOrdermadeFactoryBaseItemColorOptionValue = exports.EMSOrdermadeFactoryBaseItemVariant = exports.EMSOrdermadeFactoryBaseItem = exports.EMSOrdermadeServiceGetFactoryBaseItemsResponse = exports.EMSOrdermadeServiceGetFactoryBaseItemsRequest = exports.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse = exports.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest = exports.EMSOrdermadeServiceCalculateOmProductPricingResponse = exports.EMSOrdermadeServiceCalculateOmProductPricingRequest = exports.EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse = exports.EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest = exports.EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse = exports.EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest = exports.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult = exports.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse = exports.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject = exports.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove = exports.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem = exports.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest = exports.EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse = exports.EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest = exports.EMSOrdermadeProductListingApplicationSubmitFailure = exports.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult = exports.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse = exports.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest = exports.EMSOrdermadeServiceEditOrdermadeProductDesignResponse = exports.EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign = exports.EMSOrdermadeServiceEditOrdermadeProductDesignRequest = exports.EMSOrdermadeServiceSellOrdermadeProductNowResponse = exports.EMSOrdermadeServiceSellOrdermadeProductNowRequest = exports.EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse = exports.EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest = exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse = exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant = exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest = exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct = exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse = exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign = exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig = exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest = exports.EMSOrdermadeServiceGetOrdermadeProductByIdResponse = exports.EMSOrdermadeServiceGetOrdermadeProductByIdRequest = exports.EMSOrdermadeServiceGetOrdermadeProductsResponse = exports.EMSOrdermadeServiceGetOrdermadeProductsRequest = exports.EMSOrdermadeServiceBrandApplicationErrorReason = exports.EMSOrdermadeProductListingApplicationReviewFailureReason = exports.EMSOrdermadeProductListingApplicationSubmitFailureReason = void 0;
exports.EMSOrdermadeServiceGetBrandApplicationsResponse = exports.EMSOrdermadeServiceGetBrandApplicationsRequest = exports.EMSOrdermadeServiceGetCanCreateShopResponse = exports.EMSOrdermadeServiceGetCanCreateShopRequest = exports.EMSOrdermadeServiceGetPermissionLevelResponse = exports.EMSOrdermadeServiceGetPermissionLevelRequest = exports.EMSOrdermadeServiceSearchTalentProfilesResponse = exports.EMSOrdermadeServiceSearchTalentProfilesRequest = exports.EMSOrdermadeServiceUnpublishBrandResponse = exports.EMSOrdermadeServiceUnpublishBrandRequest = exports.EMSOrdermadeServicePublishBrandResponse = exports.EMSOrdermadeServicePublishBrandRequest = exports.EMSOrdermadeServiceRejectBrandApplicationResponse = exports.EMSOrdermadeServiceRejectBrandApplicationRequest = exports.EMSOrdermadeServiceApproveBrandApplicationResponse = exports.EMSOrdermadeServiceApproveBrandApplicationRequest = exports.EMSOrdermadeServiceGetBrandApplicationByIdResponse = exports.EMSOrdermadeServiceGetBrandApplicationByIdRequest = exports.EMSOrdermadeServiceBrandApplicationDetail = exports.EMSOrdermadeServiceBrandApplicationSummary = exports.EMSOrdermadeServiceTalentProfile = exports.EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse = exports.EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest = exports.EMSOrdermadeServiceSubmitBrandApplicationResponse = exports.EMSOrdermadeServiceSubmitBrandApplicationRequest = exports.EMSOrdermadeServiceSubmitBrandApplicationError = exports.EMSOrdermadeFactoryBaseItemSurfaceColorSpec = exports.EMSOrdermadeFactoryBaseItemPrintSurface = exports.EMSOrdermadeFactoryBaseItemImageSpec = exports.EMSOrdermadeFactoryBaseItemContainImageSpec = exports.EMSOrdermadeFactoryBaseItemAnchor = exports.EMSOrdermadeFactoryBaseItemPrintableZone = exports.EMSOrdermadeFactoryBaseItemBorderSpec = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const ems_common_pb_1 = require("./ems_common_pb");
/**
 * OM商品申請の商品ごとの失敗理由(レスポンス内に埋め込み・throwされるエラーとは別物)
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeProductListingApplicationSubmitFailureReason
 */
var EMSOrdermadeProductListingApplicationSubmitFailureReason;
(function (EMSOrdermadeProductListingApplicationSubmitFailureReason) {
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_UNSPECIFIED = 0;
     */
    EMSOrdermadeProductListingApplicationSubmitFailureReason[EMSOrdermadeProductListingApplicationSubmitFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_UNSPECIFIED";
    /**
     * 商品名が未入力
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_TITLE_INVALID = 1;
     */
    EMSOrdermadeProductListingApplicationSubmitFailureReason[EMSOrdermadeProductListingApplicationSubmitFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_TITLE_INVALID"] = 1] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_TITLE_INVALID";
    /**
     * 画像/オプション/バリアントの不備(デザイン再編集が必要)
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_DESIGN_INVALID = 2;
     */
    EMSOrdermadeProductListingApplicationSubmitFailureReason[EMSOrdermadeProductListingApplicationSubmitFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_DESIGN_INVALID"] = 2] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_DESIGN_INVALID";
    /**
     * 申請可能なステータスではない(既にsubmitted等)
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_INVALID_STATUS = 3;
     */
    EMSOrdermadeProductListingApplicationSubmitFailureReason[EMSOrdermadeProductListingApplicationSubmitFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_INVALID_STATUS"] = 3] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_INVALID_STATUS";
    /**
     * 申請権限なし(対象商品のショップに所属していない等)
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_PERMISSION_DENIED = 4;
     */
    EMSOrdermadeProductListingApplicationSubmitFailureReason[EMSOrdermadeProductListingApplicationSubmitFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_PERMISSION_DENIED"] = 4] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_PERMISSION_DENIED";
    /**
     * 販売価格が未入力
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_PRICE_INVALID = 5;
     */
    EMSOrdermadeProductListingApplicationSubmitFailureReason[EMSOrdermadeProductListingApplicationSubmitFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_PRICE_INVALID"] = 5] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_PRICE_INVALID";
    /**
     * バリエーション数がShopify上限(2048)を超えている
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_VARIANT_LIMIT_EXCEEDED = 6;
     */
    EMSOrdermadeProductListingApplicationSubmitFailureReason[EMSOrdermadeProductListingApplicationSubmitFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_VARIANT_LIMIT_EXCEEDED"] = 6] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_VARIANT_LIMIT_EXCEEDED";
    /**
     * システム内部エラー(DB等)
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_INTERNAL_ERROR = 7;
     */
    EMSOrdermadeProductListingApplicationSubmitFailureReason[EMSOrdermadeProductListingApplicationSubmitFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_INTERNAL_ERROR"] = 7] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_INTERNAL_ERROR";
    /**
     * 販売するバリエーションが1つも無い
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_NO_SELLABLE_VARIANTS = 8;
     */
    EMSOrdermadeProductListingApplicationSubmitFailureReason[EMSOrdermadeProductListingApplicationSubmitFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_NO_SELLABLE_VARIANTS"] = 8] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_NO_SELLABLE_VARIANTS";
})(EMSOrdermadeProductListingApplicationSubmitFailureReason || (exports.EMSOrdermadeProductListingApplicationSubmitFailureReason = EMSOrdermadeProductListingApplicationSubmitFailureReason = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeProductListingApplicationSubmitFailureReason)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeProductListingApplicationSubmitFailureReason, "spwn.ordermade.v1.EMSOrdermadeProductListingApplicationSubmitFailureReason", [
    { no: 0, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_TITLE_INVALID" },
    { no: 2, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_DESIGN_INVALID" },
    { no: 3, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_INVALID_STATUS" },
    { no: 4, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_PERMISSION_DENIED" },
    { no: 5, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_PRICE_INVALID" },
    { no: 6, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_VARIANT_LIMIT_EXCEEDED" },
    { no: 7, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_INTERNAL_ERROR" },
    { no: 8, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_SUBMIT_FAILURE_REASON_NO_SELLABLE_VARIANTS" },
]);
/**
 * OM商品申請の承認/却下の商品ごとの失敗理由(レスポンス内に埋め込み・throwされるエラーとは別物)
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeProductListingApplicationReviewFailureReason
 */
var EMSOrdermadeProductListingApplicationReviewFailureReason;
(function (EMSOrdermadeProductListingApplicationReviewFailureReason) {
    /**
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_UNSPECIFIED = 0;
     */
    EMSOrdermadeProductListingApplicationReviewFailureReason[EMSOrdermadeProductListingApplicationReviewFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_UNSPECIFIED";
    /**
     * 承認/却下できない状態(申請レコードが存在しない / 最新申請が submitted 以外)
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_INVALID_STATUS = 1;
     */
    EMSOrdermadeProductListingApplicationReviewFailureReason[EMSOrdermadeProductListingApplicationReviewFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_INVALID_STATUS"] = 1] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_INVALID_STATUS";
    /**
     * 承認/却下権限なし(対象ショップのマネージャーではない)
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_PERMISSION_DENIED = 2;
     */
    EMSOrdermadeProductListingApplicationReviewFailureReason[EMSOrdermadeProductListingApplicationReviewFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_PERMISSION_DENIED"] = 2] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_PERMISSION_DENIED";
    /**
     * 却下理由が不正(空 / 上限超過)
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_REJECT_REASON_INVALID = 3;
     */
    EMSOrdermadeProductListingApplicationReviewFailureReason[EMSOrdermadeProductListingApplicationReviewFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_REJECT_REASON_INVALID"] = 3] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_REJECT_REASON_INVALID";
    /**
     * 内部エラー(当該商品の DB 更新失敗)
     *
     * @generated from enum value: EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_INTERNAL_ERROR = 4;
     */
    EMSOrdermadeProductListingApplicationReviewFailureReason[EMSOrdermadeProductListingApplicationReviewFailureReason["EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_INTERNAL_ERROR"] = 4] = "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_INTERNAL_ERROR";
})(EMSOrdermadeProductListingApplicationReviewFailureReason || (exports.EMSOrdermadeProductListingApplicationReviewFailureReason = EMSOrdermadeProductListingApplicationReviewFailureReason = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeProductListingApplicationReviewFailureReason)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeProductListingApplicationReviewFailureReason, "spwn.ordermade.v1.EMSOrdermadeProductListingApplicationReviewFailureReason", [
    { no: 0, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_INVALID_STATUS" },
    { no: 2, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_PERMISSION_DENIED" },
    { no: 3, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_REJECT_REASON_INVALID" },
    { no: 4, name: "EMS_ORDERMADE_PRODUCT_LISTING_APPLICATION_REVIEW_FAILURE_REASON_INTERNAL_ERROR" },
]);
/**
 * SubmitBrandApplicationのエラー詳細（ConnectErrorのdetailsで返す）
 *
 * @generated from enum spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationErrorReason
 */
var EMSOrdermadeServiceBrandApplicationErrorReason;
(function (EMSOrdermadeServiceBrandApplicationErrorReason) {
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_UNSPECIFIED = 0;
     */
    EMSOrdermadeServiceBrandApplicationErrorReason[EMSOrdermadeServiceBrandApplicationErrorReason["EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_UNSPECIFIED"] = 0] = "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_UNSPECIFIED";
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_ALREADY_EXISTS = 1;
     */
    EMSOrdermadeServiceBrandApplicationErrorReason[EMSOrdermadeServiceBrandApplicationErrorReason["EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_ALREADY_EXISTS"] = 1] = "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_ALREADY_EXISTS";
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_PROHIBITED = 2;
     */
    EMSOrdermadeServiceBrandApplicationErrorReason[EMSOrdermadeServiceBrandApplicationErrorReason["EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_PROHIBITED"] = 2] = "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_PROHIBITED";
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_INVALID_FORMAT = 3;
     */
    EMSOrdermadeServiceBrandApplicationErrorReason[EMSOrdermadeServiceBrandApplicationErrorReason["EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_INVALID_FORMAT"] = 3] = "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_INVALID_FORMAT";
    /**
     * @generated from enum value: EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_PENDING_LIMIT_EXCEEDED = 4;
     */
    EMSOrdermadeServiceBrandApplicationErrorReason[EMSOrdermadeServiceBrandApplicationErrorReason["EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_PENDING_LIMIT_EXCEEDED"] = 4] = "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_PENDING_LIMIT_EXCEEDED";
})(EMSOrdermadeServiceBrandApplicationErrorReason || (exports.EMSOrdermadeServiceBrandApplicationErrorReason = EMSOrdermadeServiceBrandApplicationErrorReason = {}));
// Retrieve enum metadata with: proto3.getEnumType(EMSOrdermadeServiceBrandApplicationErrorReason)
protobuf_1.proto3.util.setEnumType(EMSOrdermadeServiceBrandApplicationErrorReason, "spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationErrorReason", [
    { no: 0, name: "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_UNSPECIFIED" },
    { no: 1, name: "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_ALREADY_EXISTS" },
    { no: 2, name: "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_PROHIBITED" },
    { no: 3, name: "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_SLUG_INVALID_FORMAT" },
    { no: 4, name: "EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_PENDING_LIMIT_EXCEEDED" },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductsRequest
 */
class EMSOrdermadeServiceGetOrdermadeProductsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * フィルタリング用のタグIDリスト
         *
         * @generated from field: repeated string tag_ids = 1;
         */
        this.tagIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetOrdermadeProductsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetOrdermadeProductsRequest = EMSOrdermadeServiceGetOrdermadeProductsRequest;
EMSOrdermadeServiceGetOrdermadeProductsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetOrdermadeProductsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductsRequest";
EMSOrdermadeServiceGetOrdermadeProductsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "publish_status", kind: "enum", T: protobuf_1.proto3.getEnumType(ems_common_pb_1.EMSOrdermadeProductPublishStatus), opt: true },
    { no: 3, name: "listing_review_status", kind: "enum", T: protobuf_1.proto3.getEnumType(ems_common_pb_1.EMSOrdermadeProductListingReviewStatus), opt: true },
    { no: 4, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductsResponse
 */
class EMSOrdermadeServiceGetOrdermadeProductsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductListItem products = 1;
         */
        this.products = [];
        /**
         * @generated from field: int32 total_pages = 2;
         */
        this.totalPages = 0;
        /**
         * @generated from field: int32 current_page = 3;
         */
        this.currentPage = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetOrdermadeProductsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetOrdermadeProductsResponse = EMSOrdermadeServiceGetOrdermadeProductsResponse;
EMSOrdermadeServiceGetOrdermadeProductsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetOrdermadeProductsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductsResponse";
EMSOrdermadeServiceGetOrdermadeProductsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "products", kind: "message", T: ems_common_pb_1.EMSOrdermadeProductListItem, repeated: true },
    { no: 2, name: "total_pages", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "current_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductByIdRequest
 */
class EMSOrdermadeServiceGetOrdermadeProductByIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetOrdermadeProductByIdRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetOrdermadeProductByIdRequest = EMSOrdermadeServiceGetOrdermadeProductByIdRequest;
EMSOrdermadeServiceGetOrdermadeProductByIdRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetOrdermadeProductByIdRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductByIdRequest";
EMSOrdermadeServiceGetOrdermadeProductByIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductByIdResponse
 */
class EMSOrdermadeServiceGetOrdermadeProductByIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetOrdermadeProductByIdResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetOrdermadeProductByIdResponse = EMSOrdermadeServiceGetOrdermadeProductByIdResponse;
EMSOrdermadeServiceGetOrdermadeProductByIdResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetOrdermadeProductByIdResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductByIdResponse";
EMSOrdermadeServiceGetOrdermadeProductByIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "product", kind: "message", T: ems_common_pb_1.EMSOrdermadeProduct },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest
 */
class EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * メイン画像ID
         *
         * @generated from field: string om_brand_image_id = 1;
         */
        this.omBrandImageId = "";
        /**
         * 商品マスタごとの設定
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig base_item_configs = 2;
         */
        this.baseItemConfigs = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest = EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest;
EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest";
EMSOrdermadeServiceQuickCreateOrdermadeProductsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_brand_image_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "base_item_configs", kind: "message", T: EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig
 */
class EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 工場商品マスタID
         *
         * @generated from field: string factory_base_item_id = 1;
         */
        this.factoryBaseItemId = "";
        /**
         * 販売するカラーの工場オプション値IDリスト
         *
         * @generated from field: repeated string factory_color_option_value_ids = 2;
         */
        this.factoryColorOptionValueIds = [];
        /**
         * 販売するサイズの工場オプション値IDリスト
         *
         * @generated from field: repeated string factory_size_option_value_ids = 3;
         */
        this.factorySizeOptionValueIds = [];
        /**
         * デザイン編集画面で設定した面ごとのデザイン (未編集の面は省略可)
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign surface_designs = 4;
         */
        this.surfaceDesigns = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig, a, b);
    }
}
exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig = EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig;
EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig.runtime = protobuf_1.proto3;
EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig";
EMSOrdermadeServiceQuickCreateOrdermadeProductsBaseItemConfig.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "factory_base_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "factory_color_option_value_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "factory_size_option_value_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "surface_designs", kind: "message", T: EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign
 */
class EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 印刷面ID(om_factory_print_surface.surface_codeの値)
         *
         * @generated from field: string surface_code = 1;
         */
        this.surfaceCode = "";
        /**
         * konvaが生成したデザインスペック(JSON string)
         *
         * @generated from field: string konva_design_spec = 2;
         */
        this.konvaDesignSpec = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign, a, b);
    }
}
exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign = EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign;
EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign.runtime = protobuf_1.proto3;
EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign";
EMSOrdermadeServiceQuickCreateOrdermadeProductsSurfaceDesign.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "surface_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "konva_design_spec", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse
 */
class EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 作成された商品 (id とその時点の updatedAt。
         * updatedAt は続く save の expected_product_updated_at に使う)
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct created_products = 1;
         */
        this.createdProducts = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse = EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse;
EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse";
EMSOrdermadeServiceQuickCreateOrdermadeProductsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "created_products", kind: "message", T: EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct
 */
class EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct, a, b);
    }
}
exports.EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct = EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct;
EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct.runtime = protobuf_1.proto3;
EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct";
EMSOrdermadeServiceQuickCreateOrdermadeProductsCreatedProduct.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_updated_at", kind: "message", T: protobuf_1.Timestamp },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest
 */
class EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 更新対象の商品ID
         *
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        /**
         * バリアントの更新
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant variants = 4;
         */
        this.variants = [];
        /**
         * 紐付けタレント (配列順序が priority に対応、毎回全置換、空配列でクリア)。承認済みでは無視される
         * yoshimoto_profile_id は外部システム由来のID
         *
         * @generated from field: repeated int32 yoshimoto_profile_ids = 5;
         */
        this.yoshimotoProfileIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest, a, b);
    }
}
exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest = EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest;
EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest";
EMSOrdermadeServiceUpdateOrdermadeProductDetailRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description_as_tiptap", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "variants", kind: "message", T: EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant, repeated: true },
    { no: 5, name: "yoshimoto_profile_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 6, name: "expected_product_updated_at", kind: "message", T: protobuf_1.Timestamp },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant
 */
class EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * バリアントID
         *
         * @generated from field: string om_product_variant_id = 1;
         */
        this.omProductVariantId = "";
        /**
         * 販売するかどうか（falseにすると在庫0として売り切れ表示になる）
         *
         * @generated from field: bool is_on_sale = 3;
         */
        this.isOnSale = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant, a, b);
    }
}
exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant = EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant;
EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant.runtime = protobuf_1.proto3;
EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant";
EMSOrdermadeServiceUpdateOrdermadeProductDetailVariant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "is_on_sale", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse
 */
class EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 更新した商品ID
         *
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse, a, b);
    }
}
exports.EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse = EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse;
EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse";
EMSOrdermadeServiceUpdateOrdermadeProductDetailResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_updated_at", kind: "message", T: protobuf_1.Timestamp },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest
 */
class EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest, a, b);
    }
}
exports.EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest = EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest;
EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest";
EMSOrdermadeServiceSchedulePublishOrdermadeProductRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "scheduled_publish_at", kind: "message", T: protobuf_1.Timestamp },
    { no: 3, name: "sales_start_at", kind: "message", T: protobuf_1.Timestamp },
    { no: 4, name: "sales_end_at", kind: "message", T: protobuf_1.Timestamp, opt: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse
 */
class EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse, a, b);
    }
}
exports.EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse = EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse;
EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse";
EMSOrdermadeServiceSchedulePublishOrdermadeProductResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSellOrdermadeProductNowRequest
 */
class EMSOrdermadeServiceSellOrdermadeProductNowRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSellOrdermadeProductNowRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSellOrdermadeProductNowRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSellOrdermadeProductNowRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSellOrdermadeProductNowRequest, a, b);
    }
}
exports.EMSOrdermadeServiceSellOrdermadeProductNowRequest = EMSOrdermadeServiceSellOrdermadeProductNowRequest;
EMSOrdermadeServiceSellOrdermadeProductNowRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSellOrdermadeProductNowRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSellOrdermadeProductNowRequest";
EMSOrdermadeServiceSellOrdermadeProductNowRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sales_end_at", kind: "message", T: protobuf_1.Timestamp, opt: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSellOrdermadeProductNowResponse
 */
class EMSOrdermadeServiceSellOrdermadeProductNowResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSellOrdermadeProductNowResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSellOrdermadeProductNowResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSellOrdermadeProductNowResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSellOrdermadeProductNowResponse, a, b);
    }
}
exports.EMSOrdermadeServiceSellOrdermadeProductNowResponse = EMSOrdermadeServiceSellOrdermadeProductNowResponse;
EMSOrdermadeServiceSellOrdermadeProductNowResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSellOrdermadeProductNowResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSellOrdermadeProductNowResponse";
EMSOrdermadeServiceSellOrdermadeProductNowResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * OM商品デザイン編集リクエスト
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignRequest
 */
class EMSOrdermadeServiceEditOrdermadeProductDesignRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 更新対象の商品ID
         *
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        /**
         * 販売するカラーの工場オプション値IDリスト
         *
         * @generated from field: repeated string factory_color_option_value_ids = 2;
         */
        this.factoryColorOptionValueIds = [];
        /**
         * 販売するサイズの工場オプション値IDリスト
         *
         * @generated from field: repeated string factory_size_option_value_ids = 3;
         */
        this.factorySizeOptionValueIds = [];
        /**
         * 商品に設定する全ての面のデザイン（送信された面が現状の全てとして扱われ、省略された面は削除される）
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign surface_designs = 4;
         */
        this.surfaceDesigns = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceEditOrdermadeProductDesignRequest, a, b);
    }
}
exports.EMSOrdermadeServiceEditOrdermadeProductDesignRequest = EMSOrdermadeServiceEditOrdermadeProductDesignRequest;
EMSOrdermadeServiceEditOrdermadeProductDesignRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceEditOrdermadeProductDesignRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignRequest";
EMSOrdermadeServiceEditOrdermadeProductDesignRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "factory_color_option_value_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "factory_size_option_value_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "surface_designs", kind: "message", T: EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign, repeated: true },
    { no: 5, name: "expected_product_updated_at", kind: "message", T: protobuf_1.Timestamp },
]);
/**
 * 面ごとのデザイン
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign
 */
class EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 印刷面ID(om_factory_print_surface.surface_codeの値)
         *
         * @generated from field: string surface_code = 1;
         */
        this.surfaceCode = "";
        /**
         * konvaが生成したデザインスペック(JSON string)
         *
         * @generated from field: string konva_design_spec = 2;
         */
        this.konvaDesignSpec = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign, a, b);
    }
}
exports.EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign = EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign;
EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign.runtime = protobuf_1.proto3;
EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign";
EMSOrdermadeServiceEditOrdermadeProductDesignSurfaceDesign.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "surface_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "konva_design_spec", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * OM商品デザイン編集レスポンス
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignResponse
 */
class EMSOrdermadeServiceEditOrdermadeProductDesignResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 更新した商品ID
         *
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceEditOrdermadeProductDesignResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceEditOrdermadeProductDesignResponse, a, b);
    }
}
exports.EMSOrdermadeServiceEditOrdermadeProductDesignResponse = EMSOrdermadeServiceEditOrdermadeProductDesignResponse;
EMSOrdermadeServiceEditOrdermadeProductDesignResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceEditOrdermadeProductDesignResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceEditOrdermadeProductDesignResponse";
EMSOrdermadeServiceEditOrdermadeProductDesignResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_updated_at", kind: "message", T: protobuf_1.Timestamp },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest
 */
class EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 申請対象の商品IDリスト
         *
         * @generated from field: repeated string om_product_ids = 1;
         */
        this.omProductIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest = EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest;
EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest";
EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse
 */
class EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 各商品の申請結果
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult results = 1;
         */
        this.results = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse = EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse;
EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse";
EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult
 */
class EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        /**
         * @generated from oneof spwn.ordermade.v1.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult.outcome
         */
        this.outcome = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult, a, b);
    }
}
exports.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult = EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult;
EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult";
EMSOrdermadeServiceSubmitOrdermadeProductListingApplicationsResult.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "om_product_listing_application_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "outcome" },
    { no: 3, name: "failure", kind: "message", T: EMSOrdermadeProductListingApplicationSubmitFailure, oneof: "outcome" },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeProductListingApplicationSubmitFailure
 */
class EMSOrdermadeProductListingApplicationSubmitFailure extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductListingApplicationSubmitFailureReason reasons = 1;
         */
        this.reasons = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeProductListingApplicationSubmitFailure().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeProductListingApplicationSubmitFailure().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeProductListingApplicationSubmitFailure().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeProductListingApplicationSubmitFailure, a, b);
    }
}
exports.EMSOrdermadeProductListingApplicationSubmitFailure = EMSOrdermadeProductListingApplicationSubmitFailure;
EMSOrdermadeProductListingApplicationSubmitFailure.runtime = protobuf_1.proto3;
EMSOrdermadeProductListingApplicationSubmitFailure.typeName = "spwn.ordermade.v1.EMSOrdermadeProductListingApplicationSubmitFailure";
EMSOrdermadeProductListingApplicationSubmitFailure.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "reasons", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeProductListingApplicationSubmitFailureReason), repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest
 */
class EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest, a, b);
    }
}
exports.EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest = EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest;
EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest";
EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse
 */
class EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse, a, b);
    }
}
exports.EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse = EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse;
EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse";
EMSOrdermadeServiceWithdrawOrdermadeProductListingApplicationResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest
 */
class EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem items = 1;
         */
        this.items = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest = EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest;
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest";
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem
 */
class EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        /**
         * @generated from oneof spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem.decision
         */
        this.decision = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem, a, b);
    }
}
exports.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem = EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem;
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem.runtime = protobuf_1.proto3;
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem";
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsItem.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "approve", kind: "message", T: EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove, oneof: "decision" },
    { no: 3, name: "reject", kind: "message", T: EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject, oneof: "decision" },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove
 */
class EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove, a, b);
    }
}
exports.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove = EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove;
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove.runtime = protobuf_1.proto3;
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove";
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsApprove.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject
 */
class EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string reason = 1;
         */
        this.reason = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject, a, b);
    }
}
exports.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject = EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject;
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject.runtime = protobuf_1.proto3;
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject";
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsReject.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse
 */
class EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult results = 1;
         */
        this.results = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse = EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse;
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse";
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult
 */
class EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        /**
         * @generated from oneof spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult.outcome
         */
        this.outcome = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult, a, b);
    }
}
exports.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult = EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult;
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult.runtime = protobuf_1.proto3;
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult";
EMSOrdermadeServiceReviewOrdermadeProductListingApplicationsResult.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "om_product_listing_application_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "outcome" },
    { no: 3, name: "failure_reason", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeProductListingApplicationReviewFailureReason), oneof: "outcome" },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest
 */
class EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string om_product_listing_application_id = 1;
         */
        this.omProductListingApplicationId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest = EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest;
EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest";
EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_listing_application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse
 */
class EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse = EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse;
EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse";
EMSOrdermadeServiceGetOrdermadeProductListingApplicationByIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application", kind: "message", T: ems_common_pb_1.EMSOrdermadeProductListingApplicationDetail },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest
 */
class EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest = EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest;
EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest";
EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse
 */
class EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeProductListingApplicationListItem applications = 1;
         */
        this.applications = [];
        /**
         * トータル件数
         *
         * @generated from field: int32 total_count = 2;
         */
        this.totalCount = 0;
        /**
         * 一覧全体の最後のページ番号
         *
         * @generated from field: int32 last_page_number = 3;
         */
        this.lastPageNumber = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse = EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse;
EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse";
EMSOrdermadeServiceGetSubmittedOrdermadeProductListingApplicationsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "applications", kind: "message", T: ems_common_pb_1.EMSOrdermadeProductListingApplicationListItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "last_page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceCalculateOmProductPricingRequest
 */
class EMSOrdermadeServiceCalculateOmProductPricingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 原価レンジを引くための商品ID
         *
         * @generated from field: string om_product_id = 1;
         */
        this.omProductId = "";
        /**
         * 販売価格(円)。FE のフォーム入力値をそのまま渡す
         *
         * @generated from field: int32 price = 2;
         */
        this.price = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceCalculateOmProductPricingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceCalculateOmProductPricingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceCalculateOmProductPricingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceCalculateOmProductPricingRequest, a, b);
    }
}
exports.EMSOrdermadeServiceCalculateOmProductPricingRequest = EMSOrdermadeServiceCalculateOmProductPricingRequest;
EMSOrdermadeServiceCalculateOmProductPricingRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceCalculateOmProductPricingRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceCalculateOmProductPricingRequest";
EMSOrdermadeServiceCalculateOmProductPricingRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceCalculateOmProductPricingResponse
 */
class EMSOrdermadeServiceCalculateOmProductPricingResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 商品原価レンジ (SKU単位で変動するため range)
         *
         * @generated from field: int32 min_cost = 1;
         */
        this.minCost = 0;
        /**
         * @generated from field: int32 max_cost = 2;
         */
        this.maxCost = 0;
        /**
         * デザイン料レンジ
         *
         * @generated from field: int32 min_design_fee = 3;
         */
        this.minDesignFee = 0;
        /**
         * @generated from field: int32 max_design_fee = 4;
         */
        this.maxDesignFee = 0;
        /**
         * 事務手数料
         *
         * @generated from field: int32 service_fee = 5;
         */
        this.serviceFee = 0;
        /**
         * トリブンレンジ
         *
         * @generated from field: int32 min_toribun = 6;
         */
        this.minToribun = 0;
        /**
         * @generated from field: int32 max_toribun = 7;
         */
        this.maxToribun = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceCalculateOmProductPricingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceCalculateOmProductPricingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceCalculateOmProductPricingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceCalculateOmProductPricingResponse, a, b);
    }
}
exports.EMSOrdermadeServiceCalculateOmProductPricingResponse = EMSOrdermadeServiceCalculateOmProductPricingResponse;
EMSOrdermadeServiceCalculateOmProductPricingResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceCalculateOmProductPricingResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceCalculateOmProductPricingResponse";
EMSOrdermadeServiceCalculateOmProductPricingResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "min_cost", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "max_cost", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "min_design_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "max_design_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "service_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "min_toribun", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "max_toribun", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest
 */
class EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * アップロード予定ファイル拡張子
         *
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeImageFileExtension file_extension = 1;
         */
        this.fileExtension = ems_common_pb_1.EMSOrdermadeImageFileExtension.EMS_ORDERMADE_IMAGE_FILE_EXTENSION_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest = EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest;
EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest";
EMSOrdermadeServiceGetSignedUrlForBrandImageUploadRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "file_extension", kind: "enum", T: protobuf_1.proto3.getEnumType(ems_common_pb_1.EMSOrdermadeImageFileExtension) },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse
 */
class EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 作成されたブランド画像ID
         *
         * @generated from field: string om_brand_image_id = 1;
         */
        this.omBrandImageId = "";
        /**
         * アップロード時に指定するヘッダー 基本的にcontent-typeくらいしか返さない想定
         *
         * @generated from field: map<string, string> headers_for_upload = 2;
         */
        this.headersForUpload = {};
        /**
         * アップロード用Signed URL
         *
         * @generated from field: string url_for_upload = 3;
         */
        this.urlForUpload = "";
        /**
         * アップロード後にアクセスできる公開URL
         *
         * @generated from field: string public_url = 4;
         */
        this.publicUrl = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse = EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse;
EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse";
EMSOrdermadeServiceGetSignedUrlForBrandImageUploadResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "om_brand_image_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "headers_for_upload", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 3, name: "url_for_upload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "public_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetFactoryBaseItemsRequest
 */
class EMSOrdermadeServiceGetFactoryBaseItemsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 指定した工場商品マスタのみ取得 (未指定の場合は全件)
         *
         * @generated from field: repeated string ids = 1;
         */
        this.ids = [];
        /**
         * variants (color×size 組合せ) を含めるか。行数が多くなりがちなため opt-in。
         * false (既定) の場合 variants は空配列で返す
         *
         * @generated from field: bool include_variants = 2;
         */
        this.includeVariants = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetFactoryBaseItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetFactoryBaseItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetFactoryBaseItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetFactoryBaseItemsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetFactoryBaseItemsRequest = EMSOrdermadeServiceGetFactoryBaseItemsRequest;
EMSOrdermadeServiceGetFactoryBaseItemsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetFactoryBaseItemsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetFactoryBaseItemsRequest";
EMSOrdermadeServiceGetFactoryBaseItemsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "include_variants", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetFactoryBaseItemsResponse
 */
class EMSOrdermadeServiceGetFactoryBaseItemsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeFactoryBaseItem factory_base_items = 1;
         */
        this.factoryBaseItems = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetFactoryBaseItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetFactoryBaseItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetFactoryBaseItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetFactoryBaseItemsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetFactoryBaseItemsResponse = EMSOrdermadeServiceGetFactoryBaseItemsResponse;
EMSOrdermadeServiceGetFactoryBaseItemsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetFactoryBaseItemsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetFactoryBaseItemsResponse";
EMSOrdermadeServiceGetFactoryBaseItemsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "factory_base_items", kind: "message", T: EMSOrdermadeFactoryBaseItem, repeated: true },
]);
/**
 * 工場商品マスタ
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItem
 */
class EMSOrdermadeFactoryBaseItem extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * 商品名
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * カラーオプション値一覧
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemColorOptionValue colors = 4;
         */
        this.colors = [];
        /**
         * サイズオプション値一覧
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemSizeOptionValue sizes = 5;
         */
        this.sizes = [];
        /**
         * 印刷面一覧（表示順昇順）
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemPrintSurface print_surfaces = 6;
         */
        this.printSurfaces = [];
        /**
         * 面×色ごとの仕様（ベース画像、印刷原価など）
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemSurfaceColorSpec surface_color_specs = 7;
         */
        this.surfaceColorSpecs = [];
        /**
         * 工場が提供する有効な color×size 組合せ（存在しない組合せはここに含まれない）
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemVariant variants = 8;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItem, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItem = EMSOrdermadeFactoryBaseItem;
EMSOrdermadeFactoryBaseItem.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItem.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItem";
EMSOrdermadeFactoryBaseItem.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "preview_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "colors", kind: "message", T: EMSOrdermadeFactoryBaseItemColorOptionValue, repeated: true },
    { no: 5, name: "sizes", kind: "message", T: EMSOrdermadeFactoryBaseItemSizeOptionValue, repeated: true },
    { no: 6, name: "print_surfaces", kind: "message", T: EMSOrdermadeFactoryBaseItemPrintSurface, repeated: true },
    { no: 7, name: "surface_color_specs", kind: "message", T: EMSOrdermadeFactoryBaseItemSurfaceColorSpec, repeated: true },
    { no: 8, name: "variants", kind: "message", T: EMSOrdermadeFactoryBaseItemVariant, repeated: true },
]);
/**
 * 工場が提供する有効なバリエーション（color×size の組合せ）
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemVariant
 */
class EMSOrdermadeFactoryBaseItemVariant extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * EMSOrdermadeFactoryBaseItemColorOptionValue.id と一致
         *
         * @generated from field: string color_option_value_id = 1;
         */
        this.colorOptionValueId = "";
        /**
         * EMSOrdermadeFactoryBaseItemSizeOptionValue.id と一致
         *
         * @generated from field: string size_option_value_id = 2;
         */
        this.sizeOptionValueId = "";
        /**
         * 在庫レベル (◯ IN_STOCK / △ LOW_STOCK / ✗ OUT_OF_STOCK)
         *
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeInventoryLevel inventory_level = 3;
         */
        this.inventoryLevel = ems_common_pb_1.EMSOrdermadeInventoryLevel.EMS_ORDERMADE_INVENTORY_LEVEL_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemVariant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemVariant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemVariant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemVariant, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemVariant = EMSOrdermadeFactoryBaseItemVariant;
EMSOrdermadeFactoryBaseItemVariant.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemVariant.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemVariant";
EMSOrdermadeFactoryBaseItemVariant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "color_option_value_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "size_option_value_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "inventory_level", kind: "enum", T: protobuf_1.proto3.getEnumType(ems_common_pb_1.EMSOrdermadeInventoryLevel) },
]);
/**
 * カラーオプション値
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemColorOptionValue
 */
class EMSOrdermadeFactoryBaseItemColorOptionValue extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * この色における商品本体の原価(円)。印刷原価は surface_color_specs[].printing_cost を別途参照
         *
         * @generated from field: int32 product_cost = 3;
         */
        this.productCost = 0;
        /**
         * 販売可能な最低原価(円) = product_cost + この色の最安1面の printing_cost。
         * 商品一覧の「¥XXX〜」表示や Step3 のカラーカード表示に利用する。
         * 商品は最低1面の印刷が必須のため、product_cost 単体では販売可能ではない点に注意。
         *
         * @generated from field: int32 minimum_sellable_cost = 5;
         */
        this.minimumSellableCost = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemColorOptionValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemColorOptionValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemColorOptionValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemColorOptionValue, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemColorOptionValue = EMSOrdermadeFactoryBaseItemColorOptionValue;
EMSOrdermadeFactoryBaseItemColorOptionValue.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemColorOptionValue.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemColorOptionValue";
EMSOrdermadeFactoryBaseItemColorOptionValue.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_cost", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "minimum_sellable_cost", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "color_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * サイズオプション値
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemSizeOptionValue
 */
class EMSOrdermadeFactoryBaseItemSizeOptionValue extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemSizeOptionValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemSizeOptionValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemSizeOptionValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemSizeOptionValue, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemSizeOptionValue = EMSOrdermadeFactoryBaseItemSizeOptionValue;
EMSOrdermadeFactoryBaseItemSizeOptionValue.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemSizeOptionValue.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemSizeOptionValue";
EMSOrdermadeFactoryBaseItemSizeOptionValue.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * 印刷可能範囲 (anchor 座標系に対する 0–1 ratio)
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemRatioRect
 */
class EMSOrdermadeFactoryBaseItemRatioRect extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: double left = 1;
         */
        this.left = 0;
        /**
         * @generated from field: double top = 2;
         */
        this.top = 0;
        /**
         * @generated from field: double width = 3;
         */
        this.width = 0;
        /**
         * @generated from field: double height = 4;
         */
        this.height = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemRatioRect().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemRatioRect().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemRatioRect().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemRatioRect, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemRatioRect = EMSOrdermadeFactoryBaseItemRatioRect;
EMSOrdermadeFactoryBaseItemRatioRect.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemRatioRect.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemRatioRect";
EMSOrdermadeFactoryBaseItemRatioRect.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "left", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "top", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "width", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "height", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
]);
/**
 * 比率ベースの矩形 border_spec.type === "ratio_rect"
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemRatioRectBorderSpec
 */
class EMSOrdermadeFactoryBaseItemRatioRectBorderSpec extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemRatioRectBorderSpec().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemRatioRectBorderSpec().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemRatioRectBorderSpec().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemRatioRectBorderSpec, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemRatioRectBorderSpec = EMSOrdermadeFactoryBaseItemRatioRectBorderSpec;
EMSOrdermadeFactoryBaseItemRatioRectBorderSpec.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemRatioRectBorderSpec.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemRatioRectBorderSpec";
EMSOrdermadeFactoryBaseItemRatioRectBorderSpec.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "rect", kind: "message", T: EMSOrdermadeFactoryBaseItemRatioRect },
]);
/**
 * om_factory_border.border_spec に対応。矩形(ratio_rect)以外追加した場合、oneofに追加
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemBorderSpec
 */
class EMSOrdermadeFactoryBaseItemBorderSpec extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemBorderSpec.spec
         */
        this.spec = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemBorderSpec().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemBorderSpec().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemBorderSpec().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemBorderSpec, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemBorderSpec = EMSOrdermadeFactoryBaseItemBorderSpec;
EMSOrdermadeFactoryBaseItemBorderSpec.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemBorderSpec.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemBorderSpec";
EMSOrdermadeFactoryBaseItemBorderSpec.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ratio_rect", kind: "message", T: EMSOrdermadeFactoryBaseItemRatioRectBorderSpec, oneof: "spec" },
]);
/**
 * ゾーン識別子付きの印刷可能範囲 (om_factory_border.zone_name に対応)
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemPrintableZone
 */
class EMSOrdermadeFactoryBaseItemPrintableZone extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 例: default_printable, collar
         *
         * @generated from field: string zone_name = 1;
         */
        this.zoneName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemPrintableZone().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemPrintableZone().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemPrintableZone().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemPrintableZone, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemPrintableZone = EMSOrdermadeFactoryBaseItemPrintableZone;
EMSOrdermadeFactoryBaseItemPrintableZone.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemPrintableZone.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemPrintableZone";
EMSOrdermadeFactoryBaseItemPrintableZone.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "zone_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "border_spec", kind: "message", T: EMSOrdermadeFactoryBaseItemBorderSpec },
]);
/**
 * 座標系の基準サイズ (px) — エディター側の責務でCanvasSizeと一致を想定
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemAnchor
 */
class EMSOrdermadeFactoryBaseItemAnchor extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: double width = 1;
         */
        this.width = 0;
        /**
         * @generated from field: double height = 2;
         */
        this.height = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemAnchor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemAnchor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemAnchor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemAnchor, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemAnchor = EMSOrdermadeFactoryBaseItemAnchor;
EMSOrdermadeFactoryBaseItemAnchor.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemAnchor.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemAnchor";
EMSOrdermadeFactoryBaseItemAnchor.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "width", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "height", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
]);
/**
 * image_spec.type === "contain"
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemContainImageSpec
 */
class EMSOrdermadeFactoryBaseItemContainImageSpec extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemContainImageSpec().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemContainImageSpec().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemContainImageSpec().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemContainImageSpec, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemContainImageSpec = EMSOrdermadeFactoryBaseItemContainImageSpec;
EMSOrdermadeFactoryBaseItemContainImageSpec.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemContainImageSpec.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemContainImageSpec";
EMSOrdermadeFactoryBaseItemContainImageSpec.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "anchor", kind: "message", T: EMSOrdermadeFactoryBaseItemAnchor },
    { no: 2, name: "align", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * om_factory_surface_preview.image_spec に対応。異なる配置を追加した場合、oneofに追加
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemImageSpec
 */
class EMSOrdermadeFactoryBaseItemImageSpec extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemImageSpec.spec
         */
        this.spec = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemImageSpec().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemImageSpec().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemImageSpec().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemImageSpec, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemImageSpec = EMSOrdermadeFactoryBaseItemImageSpec;
EMSOrdermadeFactoryBaseItemImageSpec.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemImageSpec.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemImageSpec";
EMSOrdermadeFactoryBaseItemImageSpec.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "contain", kind: "message", T: EMSOrdermadeFactoryBaseItemContainImageSpec, oneof: "spec" },
]);
/**
 * 印刷面
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemPrintSurface
 */
class EMSOrdermadeFactoryBaseItemPrintSurface extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string surface_code = 1;
         */
        this.surfaceCode = "";
        /**
         * 「表」「裏」「裾」など、ユーザー向け表示名
         *
         * @generated from field: string title = 2;
         */
        this.title = "";
        /**
         * ゾーンごとの印刷可能範囲
         *
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemPrintableZone printable_zones = 3;
         */
        this.printableZones = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemPrintSurface().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemPrintSurface().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemPrintSurface().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemPrintSurface, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemPrintSurface = EMSOrdermadeFactoryBaseItemPrintSurface;
EMSOrdermadeFactoryBaseItemPrintSurface.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemPrintSurface.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemPrintSurface";
EMSOrdermadeFactoryBaseItemPrintSurface.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "surface_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "printable_zones", kind: "message", T: EMSOrdermadeFactoryBaseItemPrintableZone, repeated: true },
]);
/**
 * 面×色ごとの仕様（ベース画像、印刷原価など）
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemSurfaceColorSpec
 */
class EMSOrdermadeFactoryBaseItemSurfaceColorSpec extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string surface_code = 1;
         */
        this.surfaceCode = "";
        /**
         * EMSOrdermadeFactoryBaseItemColorOptionValue.id と一致
         *
         * @generated from field: string factory_color_option_value_id = 2;
         */
        this.factoryColorOptionValueId = "";
        /**
         * ユーザーデザインを重ねる土台画像URL
         *
         * @generated from field: string base_image_url = 3;
         */
        this.baseImageUrl = "";
        /**
         * この (色, 面) の印刷原価(円)
         *
         * @generated from field: int32 printing_cost = 5;
         */
        this.printingCost = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeFactoryBaseItemSurfaceColorSpec().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeFactoryBaseItemSurfaceColorSpec().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeFactoryBaseItemSurfaceColorSpec().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeFactoryBaseItemSurfaceColorSpec, a, b);
    }
}
exports.EMSOrdermadeFactoryBaseItemSurfaceColorSpec = EMSOrdermadeFactoryBaseItemSurfaceColorSpec;
EMSOrdermadeFactoryBaseItemSurfaceColorSpec.runtime = protobuf_1.proto3;
EMSOrdermadeFactoryBaseItemSurfaceColorSpec.typeName = "spwn.ordermade.v1.EMSOrdermadeFactoryBaseItemSurfaceColorSpec";
EMSOrdermadeFactoryBaseItemSurfaceColorSpec.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "surface_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "factory_color_option_value_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "base_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "image_spec", kind: "message", T: EMSOrdermadeFactoryBaseItemImageSpec },
    { no: 5, name: "printing_cost", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSubmitBrandApplicationError
 */
class EMSOrdermadeServiceSubmitBrandApplicationError extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationErrorReason reason = 1;
         */
        this.reason = EMSOrdermadeServiceBrandApplicationErrorReason.EMS_ORDERMADE_SERVICE_BRAND_APPLICATION_ERROR_REASON_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSubmitBrandApplicationError, a, b);
    }
}
exports.EMSOrdermadeServiceSubmitBrandApplicationError = EMSOrdermadeServiceSubmitBrandApplicationError;
EMSOrdermadeServiceSubmitBrandApplicationError.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSubmitBrandApplicationError.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSubmitBrandApplicationError";
EMSOrdermadeServiceSubmitBrandApplicationError.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "reason", kind: "enum", T: protobuf_1.proto3.getEnumType(EMSOrdermadeServiceBrandApplicationErrorReason) },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSubmitBrandApplicationRequest
 */
class EMSOrdermadeServiceSubmitBrandApplicationRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string shop_name = 1;
         */
        this.shopName = "";
        /**
         * @generated from field: string slug = 2;
         */
        this.slug = "";
        /**
         * @generated from field: repeated int32 talent_ids = 3;
         */
        this.talentIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSubmitBrandApplicationRequest, a, b);
    }
}
exports.EMSOrdermadeServiceSubmitBrandApplicationRequest = EMSOrdermadeServiceSubmitBrandApplicationRequest;
EMSOrdermadeServiceSubmitBrandApplicationRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSubmitBrandApplicationRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSubmitBrandApplicationRequest";
EMSOrdermadeServiceSubmitBrandApplicationRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shop_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "talent_ids", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSubmitBrandApplicationResponse
 */
class EMSOrdermadeServiceSubmitBrandApplicationResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSubmitBrandApplicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSubmitBrandApplicationResponse, a, b);
    }
}
exports.EMSOrdermadeServiceSubmitBrandApplicationResponse = EMSOrdermadeServiceSubmitBrandApplicationResponse;
EMSOrdermadeServiceSubmitBrandApplicationResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSubmitBrandApplicationResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSubmitBrandApplicationResponse";
EMSOrdermadeServiceSubmitBrandApplicationResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest
 */
class EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest = EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest;
EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest";
EMSOrdermadeServiceGetMyPendingBrandApplicationsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse
 */
class EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated string shop_names = 1;
         */
        this.shopNames = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse = EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse;
EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse";
EMSOrdermadeServiceGetMyPendingBrandApplicationsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shop_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * タレントプロフィール（SearchTalentProfilesでも再利用）
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceTalentProfile
 */
class EMSOrdermadeServiceTalentProfile extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 talent_id = 1;
         */
        this.talentId = 0;
        /**
         * @generated from field: string talent_name = 2;
         */
        this.talentName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceTalentProfile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceTalentProfile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceTalentProfile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceTalentProfile, a, b);
    }
}
exports.EMSOrdermadeServiceTalentProfile = EMSOrdermadeServiceTalentProfile;
EMSOrdermadeServiceTalentProfile.runtime = protobuf_1.proto3;
EMSOrdermadeServiceTalentProfile.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceTalentProfile";
EMSOrdermadeServiceTalentProfile.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "talent_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "talent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * 販売元追加申請一覧用
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationSummary
 */
class EMSOrdermadeServiceBrandApplicationSummary extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string application_id = 1;
         */
        this.applicationId = "";
        /**
         * @generated from field: string shop_name = 2;
         */
        this.shopName = "";
        /**
         * @generated from field: string slug = 3;
         */
        this.slug = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceBrandApplicationSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceBrandApplicationSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceBrandApplicationSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceBrandApplicationSummary, a, b);
    }
}
exports.EMSOrdermadeServiceBrandApplicationSummary = EMSOrdermadeServiceBrandApplicationSummary;
EMSOrdermadeServiceBrandApplicationSummary.runtime = protobuf_1.proto3;
EMSOrdermadeServiceBrandApplicationSummary.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationSummary";
EMSOrdermadeServiceBrandApplicationSummary.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shop_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "submitted_at", kind: "message", T: protobuf_1.Timestamp },
]);
/**
 * 販売元追加申請詳細（承認/却下判断に必要な情報）
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationDetail
 */
class EMSOrdermadeServiceBrandApplicationDetail extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string application_id = 1;
         */
        this.applicationId = "";
        /**
         * @generated from field: string shop_name = 2;
         */
        this.shopName = "";
        /**
         * @generated from field: string slug = 3;
         */
        this.slug = "";
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceTalentProfile talents = 4;
         */
        this.talents = [];
        /**
         * @generated from field: string applicant_email = 5;
         */
        this.applicantEmail = "";
        /**
         * @generated from field: string applicant_name = 6;
         */
        this.applicantName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceBrandApplicationDetail().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceBrandApplicationDetail().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceBrandApplicationDetail().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceBrandApplicationDetail, a, b);
    }
}
exports.EMSOrdermadeServiceBrandApplicationDetail = EMSOrdermadeServiceBrandApplicationDetail;
EMSOrdermadeServiceBrandApplicationDetail.runtime = protobuf_1.proto3;
EMSOrdermadeServiceBrandApplicationDetail.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationDetail";
EMSOrdermadeServiceBrandApplicationDetail.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shop_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "talents", kind: "message", T: EMSOrdermadeServiceTalentProfile, repeated: true },
    { no: 5, name: "applicant_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "applicant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "message", T: protobuf_1.Timestamp },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationByIdRequest
 */
class EMSOrdermadeServiceGetBrandApplicationByIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string application_id = 1;
         */
        this.applicationId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetBrandApplicationByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetBrandApplicationByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetBrandApplicationByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetBrandApplicationByIdRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetBrandApplicationByIdRequest = EMSOrdermadeServiceGetBrandApplicationByIdRequest;
EMSOrdermadeServiceGetBrandApplicationByIdRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetBrandApplicationByIdRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationByIdRequest";
EMSOrdermadeServiceGetBrandApplicationByIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationByIdResponse
 */
class EMSOrdermadeServiceGetBrandApplicationByIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetBrandApplicationByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetBrandApplicationByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetBrandApplicationByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetBrandApplicationByIdResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetBrandApplicationByIdResponse = EMSOrdermadeServiceGetBrandApplicationByIdResponse;
EMSOrdermadeServiceGetBrandApplicationByIdResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetBrandApplicationByIdResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationByIdResponse";
EMSOrdermadeServiceGetBrandApplicationByIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application", kind: "message", T: EMSOrdermadeServiceBrandApplicationDetail },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceApproveBrandApplicationRequest
 */
class EMSOrdermadeServiceApproveBrandApplicationRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string application_id = 1;
         */
        this.applicationId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceApproveBrandApplicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceApproveBrandApplicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceApproveBrandApplicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceApproveBrandApplicationRequest, a, b);
    }
}
exports.EMSOrdermadeServiceApproveBrandApplicationRequest = EMSOrdermadeServiceApproveBrandApplicationRequest;
EMSOrdermadeServiceApproveBrandApplicationRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceApproveBrandApplicationRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceApproveBrandApplicationRequest";
EMSOrdermadeServiceApproveBrandApplicationRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceApproveBrandApplicationResponse
 */
class EMSOrdermadeServiceApproveBrandApplicationResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceApproveBrandApplicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceApproveBrandApplicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceApproveBrandApplicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceApproveBrandApplicationResponse, a, b);
    }
}
exports.EMSOrdermadeServiceApproveBrandApplicationResponse = EMSOrdermadeServiceApproveBrandApplicationResponse;
EMSOrdermadeServiceApproveBrandApplicationResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceApproveBrandApplicationResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceApproveBrandApplicationResponse";
EMSOrdermadeServiceApproveBrandApplicationResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceRejectBrandApplicationRequest
 */
class EMSOrdermadeServiceRejectBrandApplicationRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string application_id = 1;
         */
        this.applicationId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceRejectBrandApplicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceRejectBrandApplicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceRejectBrandApplicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceRejectBrandApplicationRequest, a, b);
    }
}
exports.EMSOrdermadeServiceRejectBrandApplicationRequest = EMSOrdermadeServiceRejectBrandApplicationRequest;
EMSOrdermadeServiceRejectBrandApplicationRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceRejectBrandApplicationRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceRejectBrandApplicationRequest";
EMSOrdermadeServiceRejectBrandApplicationRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceRejectBrandApplicationResponse
 */
class EMSOrdermadeServiceRejectBrandApplicationResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceRejectBrandApplicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceRejectBrandApplicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceRejectBrandApplicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceRejectBrandApplicationResponse, a, b);
    }
}
exports.EMSOrdermadeServiceRejectBrandApplicationResponse = EMSOrdermadeServiceRejectBrandApplicationResponse;
EMSOrdermadeServiceRejectBrandApplicationResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceRejectBrandApplicationResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceRejectBrandApplicationResponse";
EMSOrdermadeServiceRejectBrandApplicationResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * ブランドは TenantId + BrandSlug ヘッダー経由で認可・特定するため body フィールドは持たない。
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServicePublishBrandRequest
 */
class EMSOrdermadeServicePublishBrandRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServicePublishBrandRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServicePublishBrandRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServicePublishBrandRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServicePublishBrandRequest, a, b);
    }
}
exports.EMSOrdermadeServicePublishBrandRequest = EMSOrdermadeServicePublishBrandRequest;
EMSOrdermadeServicePublishBrandRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServicePublishBrandRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServicePublishBrandRequest";
EMSOrdermadeServicePublishBrandRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServicePublishBrandResponse
 */
class EMSOrdermadeServicePublishBrandResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServicePublishBrandResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServicePublishBrandResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServicePublishBrandResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServicePublishBrandResponse, a, b);
    }
}
exports.EMSOrdermadeServicePublishBrandResponse = EMSOrdermadeServicePublishBrandResponse;
EMSOrdermadeServicePublishBrandResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServicePublishBrandResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServicePublishBrandResponse";
EMSOrdermadeServicePublishBrandResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * ブランドは TenantId + BrandSlug ヘッダー経由で認可・特定するため body フィールドは持たない。
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceUnpublishBrandRequest
 */
class EMSOrdermadeServiceUnpublishBrandRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceUnpublishBrandRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceUnpublishBrandRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceUnpublishBrandRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceUnpublishBrandRequest, a, b);
    }
}
exports.EMSOrdermadeServiceUnpublishBrandRequest = EMSOrdermadeServiceUnpublishBrandRequest;
EMSOrdermadeServiceUnpublishBrandRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceUnpublishBrandRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceUnpublishBrandRequest";
EMSOrdermadeServiceUnpublishBrandRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceUnpublishBrandResponse
 */
class EMSOrdermadeServiceUnpublishBrandResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceUnpublishBrandResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceUnpublishBrandResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceUnpublishBrandResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceUnpublishBrandResponse, a, b);
    }
}
exports.EMSOrdermadeServiceUnpublishBrandResponse = EMSOrdermadeServiceUnpublishBrandResponse;
EMSOrdermadeServiceUnpublishBrandResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceUnpublishBrandResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceUnpublishBrandResponse";
EMSOrdermadeServiceUnpublishBrandResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSearchTalentProfilesRequest
 */
class EMSOrdermadeServiceSearchTalentProfilesRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated int64 profile_ids = 1;
         */
        this.profileIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSearchTalentProfilesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSearchTalentProfilesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSearchTalentProfilesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSearchTalentProfilesRequest, a, b);
    }
}
exports.EMSOrdermadeServiceSearchTalentProfilesRequest = EMSOrdermadeServiceSearchTalentProfilesRequest;
EMSOrdermadeServiceSearchTalentProfilesRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSearchTalentProfilesRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSearchTalentProfilesRequest";
EMSOrdermadeServiceSearchTalentProfilesRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "profile_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceSearchTalentProfilesResponse
 */
class EMSOrdermadeServiceSearchTalentProfilesResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceTalentProfile talents = 1;
         */
        this.talents = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceSearchTalentProfilesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceSearchTalentProfilesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceSearchTalentProfilesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceSearchTalentProfilesResponse, a, b);
    }
}
exports.EMSOrdermadeServiceSearchTalentProfilesResponse = EMSOrdermadeServiceSearchTalentProfilesResponse;
EMSOrdermadeServiceSearchTalentProfilesResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceSearchTalentProfilesResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceSearchTalentProfilesResponse";
EMSOrdermadeServiceSearchTalentProfilesResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "talents", kind: "message", T: EMSOrdermadeServiceTalentProfile, repeated: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetPermissionLevelRequest
 */
class EMSOrdermadeServiceGetPermissionLevelRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetPermissionLevelRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetPermissionLevelRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetPermissionLevelRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetPermissionLevelRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetPermissionLevelRequest = EMSOrdermadeServiceGetPermissionLevelRequest;
EMSOrdermadeServiceGetPermissionLevelRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetPermissionLevelRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetPermissionLevelRequest";
EMSOrdermadeServiceGetPermissionLevelRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetPermissionLevelResponse
 */
class EMSOrdermadeServiceGetPermissionLevelResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool can_review_shop_application = 1;
         */
        this.canReviewShopApplication = false;
        /**
         * @generated from field: bool can_manage_user_invitations = 2;
         */
        this.canManageUserInvitations = false;
        /**
         * @generated from field: bool can_change_user_roles = 3;
         */
        this.canChangeUserRoles = false;
        /**
         * @generated from field: bool can_delete_users = 4;
         */
        this.canDeleteUsers = false;
        /**
         * @generated from field: bool can_approve_product_for_sale = 5;
         */
        this.canApproveProductForSale = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetPermissionLevelResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetPermissionLevelResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetPermissionLevelResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetPermissionLevelResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetPermissionLevelResponse = EMSOrdermadeServiceGetPermissionLevelResponse;
EMSOrdermadeServiceGetPermissionLevelResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetPermissionLevelResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetPermissionLevelResponse";
EMSOrdermadeServiceGetPermissionLevelResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "can_review_shop_application", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "can_manage_user_invitations", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "can_change_user_roles", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "can_delete_users", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "can_approve_product_for_sale", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetCanCreateShopRequest
 */
class EMSOrdermadeServiceGetCanCreateShopRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetCanCreateShopRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetCanCreateShopRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetCanCreateShopRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetCanCreateShopRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetCanCreateShopRequest = EMSOrdermadeServiceGetCanCreateShopRequest;
EMSOrdermadeServiceGetCanCreateShopRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetCanCreateShopRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetCanCreateShopRequest";
EMSOrdermadeServiceGetCanCreateShopRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetCanCreateShopResponse
 */
class EMSOrdermadeServiceGetCanCreateShopResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool can_create_shop = 1;
         */
        this.canCreateShop = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetCanCreateShopResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetCanCreateShopResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetCanCreateShopResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetCanCreateShopResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetCanCreateShopResponse = EMSOrdermadeServiceGetCanCreateShopResponse;
EMSOrdermadeServiceGetCanCreateShopResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetCanCreateShopResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetCanCreateShopResponse";
EMSOrdermadeServiceGetCanCreateShopResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "can_create_shop", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * 申請日時の降順（新しい順）で返す
 *
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationsRequest
 */
class EMSOrdermadeServiceGetBrandApplicationsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetBrandApplicationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetBrandApplicationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetBrandApplicationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetBrandApplicationsRequest, a, b);
    }
}
exports.EMSOrdermadeServiceGetBrandApplicationsRequest = EMSOrdermadeServiceGetBrandApplicationsRequest;
EMSOrdermadeServiceGetBrandApplicationsRequest.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetBrandApplicationsRequest.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationsRequest";
EMSOrdermadeServiceGetBrandApplicationsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 2, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationsResponse
 */
class EMSOrdermadeServiceGetBrandApplicationsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.ordermade.v1.EMSOrdermadeServiceBrandApplicationSummary applications = 1;
         */
        this.applications = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EMSOrdermadeServiceGetBrandApplicationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EMSOrdermadeServiceGetBrandApplicationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EMSOrdermadeServiceGetBrandApplicationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EMSOrdermadeServiceGetBrandApplicationsResponse, a, b);
    }
}
exports.EMSOrdermadeServiceGetBrandApplicationsResponse = EMSOrdermadeServiceGetBrandApplicationsResponse;
EMSOrdermadeServiceGetBrandApplicationsResponse.runtime = protobuf_1.proto3;
EMSOrdermadeServiceGetBrandApplicationsResponse.typeName = "spwn.ordermade.v1.EMSOrdermadeServiceGetBrandApplicationsResponse";
EMSOrdermadeServiceGetBrandApplicationsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "applications", kind: "message", T: EMSOrdermadeServiceBrandApplicationSummary, repeated: true },
]);
//# sourceMappingURL=ems_service_pb.js.map